import { utils, writeFile } from 'xlsx'

/**
 * 生成树型结构
 * @param {Object} source 源数据，以id和fid为条件分级
 * @param {Boolean} disabled 是否设置禁用目录
 */
function setTreeData(source, disabled = false) {
    let cloneData = JSON.parse(JSON.stringify(source)); // 对源数据深度克隆
    return cloneData.filter(father => {
        // 循环所有项，并添加children属性
        let branchArr = cloneData.filter(child => father.id == child.fid); // 返回每一项的子级数组
        branchArr.length > 0 ? (father.children = branchArr) : ""; //给父级添加一个children属性，并赋值
        // 是否设置禁用目录
        disabled && !father.children & !father.value && (father.disabled = true);
        return !father.fid; //返回第一层
    });
}

/**
 * 返回格式化的时间
 * @param {Date} date 当前需要格式化的时间对象
 * @param {Boolean} isTime 是否显示时分秒
 * @param {Boolean} onlyTime 是否仅仅只显示时分秒
 */
function getYear(date, isTime, onlyTime) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let time = year + "-" + get0(month) + "-" + get0(day);
    if (isTime) {
        let hour = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (onlyTime) {
            time = get0(hour) + ":" + get0(minutes) + ":" + get0(seconds);
        } else {
            time += " " + get0(hour) + ":" + get0(minutes) + ":" + get0(seconds);
        }
    }
    return time;
}
function get0(num) {
    return num < 10 ? "0" + num : num;
}

/**
 * 反转对象
 * @param {object} object 对象
 */
function reverseObject(object) {
    let NewObj = {},
        keysArr = Object.keys(object);
    for (let i = keysArr.length - 1; i >= 0; i--) {
        NewObj[keysArr[i]] = object[keysArr[i]];
    }
    return NewObj;
}

/**
 * 返回一个排除掉 value 为 null 的新对象
 * @param {object} obj params 接口参数对象
 * @returns 排除掉 value 为 null 的新对象
 */
function excludeNullProperty(obj) {
    const params = {}
    for (const key in obj) {
        if (obj[key] !== null) {
            params[key] = obj[key]
        }
    }
    return params
}

/**
 * 将表格的列表数据下载成 excel
 * @param {Array} dataList 表格数据列表
 * @param {object} fieldMapName 表格中的 prop: label
 * @param {String} excelName excel 的名称需要带上后缀
 */
function dataListToExcel(dataList, fieldMapName, excelName) {
    const fieldReg = /[A-Z]*1$/
    const book = utils.book_new()
    const sheets = utils.json_to_sheet(dataList)
    utils.book_append_sheet(book, sheets, "测试sheet")

    for (const key in sheets) {
        if (fieldReg.test(key)) {
            const rawKey = sheets[key].v
            sheets[key].v = fieldMapName[rawKey]
        }
    }

    writeFile(book, excelName)
}

/**
 * 下载接口返回的数据流(xls)
 * @param {binary} binaryData 数据流
 */
function downloadExcel(binaryData) {
    const blob = new Blob([binaryData], { type: "application/vnd.ms-excel;charset=utf-8" })
    const link = window.URL.createObjectURL(blob)
    window.open(link, "_blank")
}

export { setTreeData, getYear, reverseObject, excludeNullProperty, dataListToExcel, downloadExcel }